import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/trimmis.scss';
import { Link } from 'react-router';

class ImageLink extends Component {


  render() {
    const styles = {
      backgroundImage: 'url('+this.props.imgUrl+')',
      height: this.props.height
    };
    const buttonStyle = {
      marginTop: "10px"
    };
    let rendering = null;
    if (this.props.imageAsLink){
      rendering = ( <Link to={this.props.link} className="img-holder" style={styles}>
        <div className="img-holder-container">
            <div className="img-holder-text">{this.props.text}</div>
        </div>
      </Link>)
    } else {
      rendering = (<div className="img-holder" style={styles}>
        <div className="img-holder-container">
          <div className="img-holder-text">{this.props.text}</div>
          <Link to={this.props.link} className="info-button-reverse" style={buttonStyle}>{this.props.linkText}</Link>
        </div>
      </div>)
    }

    return (
      rendering
    );
  }
}

export default ImageLink;



// WEBPACK FOOTER //
// ../components/ImageLink.js